<template>
  <div class="create_user">
    <div class="user_head">
      <div class="user_head_left">
        <span class="vertical_line"></span>{{ $t("cases.createUser.jbxx") }}
      </div>
      <p class="user_head_p">
        <span class="user_head_sp"
        >{{ $t("casesDetail.casesChildren.restartCases.blh") }}:</span
        >
        <span class="case_number">{{ caseNumber || "-" }}</span>
      </p>
    </div>
    <div v-if="problemList.length > 0" class="dia_problem">
      <h5>{{ $t("cases.createImage.czrxwt") }}</h5>
      <div class="pro_box">
        <span v-for="(item, index) in problemList" :key="index">
          {{ item.groupName }} : {{ item.content }}
        </span>
      </div>
    </div>
    <ul class="form_ul">
      <li class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("cases.createUser.hzmc") }}：
        </div>
        <div class="f_single_right">
          <input
              v-model="userForm.realName"
              :placeholder="$t('cases.createUser.qsr')"
              type="text"
              maxlength="100"
          />
        </div>
      </li>
      <li class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("cases.createUser.xb") }}：
        </div>
        <div class="f_single_right" style="display: flex; align-items: center">
          <el-radio v-model="userForm.sex" label="1"
          >{{ $t("cases.createUser.n") }}
          </el-radio>
          <el-radio v-model="userForm.sex" label="2"
          >{{ $t("cases.createUser.v") }}
          </el-radio>
        </div>
      </li>
      <li class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span>
          {{ $t("cases.createUser.csrq") }}：
        </div>
        <div class="f_single_right flex-y-c">
          <el-date-picker
              v-model="birthday"
              :picker-options="pickerOptions"
              :placeholder="$t('cases.createUser.xzrq')"
              style="width: 2.74rem"
              type="date"
              value-format="yyyy-MM-dd"
              @change="datePickerValue"
          >
          </el-date-picker>
          <!-- <div v-if="!userForm.birthday" class="ml20 fz12 main_theme_color_red">
            {{ birthdayHintText }}
          </div> -->
        </div>
      </li>
      <li
          :style="userForm.receiveType === '2' ? 'margin-top: -0.1rem' : ''"
          class="f_single"
      >
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.1rem; text-align: left;padding-left: 0.15rem'
              : ''
          "
            class="f_single_left"
        >
          {{ $t("birdie.lxdh") }}：
        </div>
        <div class="f_single_right">
          <input
              v-model="userForm.mobile"
              :placeholder="$t('cases.createUser.qsrlxdh')"
          />
        </div>
      </li>
      <li class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("cases.cases.cp") }}：
        </div>
        <el-select
            v-model="userForm.productId"
            :disabled="isDisabledProduct"
            :placeholder="$t('common.message.qxz')"
            clearable
            style="width: 2.74rem"
            @change="selectProduct"
        >
          <el-option
              v-for="(item, index) in productList"
              :key="index"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </li>
      <li v-if="bindProductList.length" class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span>{{ $t("cases.createUser.tcbdcp") }} ：
        </div>
        <el-select
            v-model="bindProductId"
            :disabled="isDisabledBindProduct"
            clearable
            style="width: 2.74rem"
            @change="selectBindProduct"
        >
          <el-option
              v-for="(item, index) in bindProductList"
              :key="index"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </li>
      <div class="user_head" style="margin-bottom: 30px;">
        <div class="user_head_left">
          <span class="vertical_line"></span>{{ $t("医疗机构") }}
        </div>
      </div>
      <li class="f_single" style="position: relative">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span>{{ $t("医疗机构") }}：
        </div>
        <el-select
            v-model="userForm.clinicId"
            :disabled="disableClinicSelect"
            :placeholder="$t('common.message.qxz')"
            clearable
            style="width: 2.74rem"
            @change="selectedClinic"
        >
          <!--          :disabled="disabledCLinic(item)"-->

          <el-option
              v-for="item in clinicList"
              v-show="item.status === '1'"
              :key="item.id"
              :class="{
              'gray-option': !signedClinicIds.includes(item.id)
            }"
              :disabled="!signedClinicIds.includes(item.id)"
              :label="item.name"
              :value="item.id"
              style="width: 500px !important;"
          >
            <span :title="item.name" class="txt-ellipsis">{{ item.name }}</span>
            <span
                v-if="!signedClinicIds.includes(item.id)"
                style="float: right; color: #8492a6; font-size: 13px"
            >不可用</span
            >
          </el-option>
        </el-select>
        <br/>
        <p class="disabled_txt">
          {{ clinicDisableText }}
        </p>
      </li>

      <li class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("cases.createUser.hzjsyt") }}：
        </div>
        <div class="f_single_right" style="display: flex; align-items: center">
          <el-radio v-model="userForm.receiveType" label="1"
          >{{ $t("cases.createUser.zssh") }}
          </el-radio>
          <el-radio v-model="userForm.receiveType" label="3">
            {{ $t("yssh.yssh") }}
          </el-radio>
          <el-radio v-model="userForm.receiveType" label="2"
          >{{ $t("cases.createUser.trsh") }}
          </el-radio>
        </div>
      </li>
      <li v-show="userForm.receiveType === '1'" class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("收货地址") }}：
        </div>
        <div class="f_single_right">
          <el-select v-model="clinicAddressId" style="width: 2.74rem">
            <el-option
                v-for="(item, index) in clinicAddressList"
                :key="index"
                :label="item.clinicAddress"
                :title="item.clinicAddress"
                :value="item.id"
                style="max-width: 9rem !important;"
            >
            </el-option>
          </el-select>
        </div>
      </li>
      <li v-show="userForm.receiveType === '3'" class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("yssh.ysshdz") }}：
        </div>
        <div class="f_single_right" style="display: flex; align-items: center">
          <div
              :class="
              doctorAddressId === '' ? 'doctor-select' : 'doctor-select-active'
            "
              :title="
              doctorAddressId === '' ? $t('yssh.djdzxz') : renderAddressText()
            "
              @click="showDoctorAddressDia"
          >
            {{
              doctorAddressId === "" ? $t("yssh.djdzxz") : renderAddressText()
            }}
          </div>
          <span class="select-text" @click="showDoctorAddressDia">{{
              $t("yssh.dzxz")
            }}</span>
        </div>
      </li>
      <li v-show="userForm.receiveType === '2'" class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          {{ $t("cases.createUser.znjx") }}：
        </div>
        <div class="iup_box">
          <div class="f_single_right">
            <textarea
                v-model="address"
                :placeholder="$t('cases.createUser.znjxplaceholder')"
                class="message-add"
                rows="3"
            />
            <a class="message-parse" @click="getMessage">{{
                $t("cases.createUser.jx")
              }}</a>
            <span class="message-reset" @click="resetMessage">{{
                $t("cases.createUser.qk")
              }}</span>
          </div>
          <span class="tip">{{ $t("cases.createUser.jxhqhsxx") }}</span>
        </div>
      </li>
      <li v-show="userForm.receiveType === '2'" class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span> {{ $t("cases.createUser.sjrxm") }}：
        </div>
        <div class="f_single_right">
          <input
              v-model="userForm.receiver"
              :placeholder="$t('cases.createUser.qtxsjrxm')"
          />
        </div>
      </li>

      <li v-show="userForm.receiveType === '2'" class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          <span class="d_require">●</span>
          {{ $t("cases.createUser.sjrsjhm") }}：
        </div>
        <div class="f_single_right" style="display: flex">
          <el-select v-model="contactWay" @change="changeContactWay">
            <el-option
                v-for="item in contactWayList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            >
            </el-option>
          </el-select>
          <input
              v-if="contactWay == 1"
              v-model="userForm.receiverMobile"
              :placeholder="$t('cases.createUser.qsrsjrsjhm')"
              style="margin-left: 0.2rem; width: 3.5rem;"
              type="number"
          />
          <div
              v-if="contactWay == 2"
              style="margin-left: 0.2rem; display: flex; align-items: center"
          >
            <input
                v-model="userForm.phoneArea"
                :placeholder="$t('birdie.qh')"
                style="width: 1rem; width: 1.5rem;"
                type="number"
            />
            <div
                style="width: 0.3rem;height: 1px;background:#bbbbbb;margin: 0.01rem;"
            />
            <input
                v-model="userForm.receiverMobile"
                :placeholder="$t('birdie.dhhm')"
                type="number"
            />
          </div>
        </div>
      </li>

      <li
          v-show="userForm.receiveType === '2'"
          class="f_single"
          style="align-items: self-start"
      >
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
            style="padding-top: 0.1rem"
        >
          <span v-show="userForm.receiveType === '2'" class="d_require">●</span>
          {{ $t("cases.createUser.dz") }}：
        </div>
        <div class="f_single_right">
          <div class="select_box">
            <el-select
                v-model="userForm.province"
                :placeholder="$t('cases.createUser.sf')"
                @change="changeProvince"
            >
              <el-option
                  v-for="(item, index) in cityData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
            <el-select
                v-model="userForm.city"
                :placeholder="$t('cases.createUser.cs')"
                style="margin: 0 0.2rem"
                @change="changeCity"
            >
              <el-option
                  v-for="(item, index) in theCityList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
            <el-select
                v-model="userForm.area"
                :placeholder="$t('cases.createUser.qx')"
            >
              <el-option
                  v-for="(item, index) in countyList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="iup_box flex-y-c">
            <div
                :style="
                language === 'en_US'
                  ? 'width: 1.8rem; margin-left: -2.4rem;margin-right: 0.6rem'
                  : 'margin-left: -1.5rem;'
              "
                class="f_single_left"
            >
              <span v-show="userForm.receiveType === '2'" class="d_require"
              >●</span
              >
              {{ $t("cases.createUser.xxdz") }}：
            </div>
            <input
                v-model="userForm.address"
                :placeholder="$t('cases.createUser.xxdz')"
                type="text"
            />
          </div>
        </div>
      </li>
    </ul>
    <div v-if="showRdtAssist" class="user_head">
      <div class="user_head_left">
        <span class="vertical_line"></span>{{ $t("iRDT协助") }}
        <el-popover placement="top-start" trigger="click">
          <span
              :style="{
              color: '#fcc80e',
              // textDecoration: 'underline',
              cursor: 'pointer'
            }"
              @click="jumpClinicalPreferences"
          >{{ $t("什么是iRDT协助") }}</span
          >
          <i slot="reference" class="icon_question" style="cursor: pointer;"/>
        </el-popover>
      </div>
    </div>
    <ul v-if="showRdtAssist" class="form_ul" style="margin-bottom: 0;">
      <li class="f_single">
        <div
            :style="
            language === 'en_US'
              ? 'width: 2.3rem; text-align: left;margin-right:0'
              : ''
          "
            class="f_single_left"
        >
          {{ $t("是否iRDT协助") }}：
        </div>
        <div class="f_single_right" style="display: flex; align-items: center">
          <div
              :class="`rdt_btn ${helpFlag === '1' ? 'rdt_btn_active' : ''}`"
              @click="changeRdt('1')"
          >
            {{ $t("需要") }}
          </div>
          <div
              :class="`rdt_btn ${helpFlag === '0' ? 'rdt_btn_active' : ''}`"
              @click="changeRdt('0')"
          >
            {{ $t("不需要") }}
          </div>
        </div>
      </li>
    </ul>
    <full-loading v-show="isLoading"/>
    <el-dialog
        :before-close="closeDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :title="$t('casesDetail.clinicalPreferences.RTD')"
        width="4.58rem"
    >
      <p class="rdt_text">
        <span>{{ $t("casesDetail.clinicalPreferences.sfxyRTD") }}</span>
        <span
            :style="{
            color: '#fcc80e',
            textDecoration: 'underline',
            cursor: 'pointer'
          }"
            @click="jumpClinicalPreferences"
        >
          {{ $t("casesDetail.clinicalPreferences.smsRTD") }}
        </span>
      </p>
      <div slot="footer" class="dialog-footer">
        <div
            :class="{ no_need_btn_en: language === 'en_US' }"
            class="no_need_btn flex-x-y-c curp fz14 main_theme_color_333"
            @click="needRDT(0)"
        >
          {{ $t("casesDetail.clinicalPreferences.bxy") }}
        </div>
        <div
            :class="{ no_need_btn_en: language === 'en_US' }"
            class="need_btn flex-x-y-c curp fz14 main_theme_color_333"
            @click="needRDT(1)"
        >
          {{ $t("casesDetail.clinicalPreferences.xy") }}
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :show-close="false"
        :visible="showDoctorAddress"
        class="address-dia"
        width="588px"
        @close="showDoctorAddress = false"
    >
      <div class="dia-header">
        <div class="title">
          {{ $t("yssh.dzxz") }}
          <div class="add-address" @click="addDoctorAddress">
            <img alt="" src="../../../common/imgs/personal/position.png"/>
            {{ $t("yssh.tjdz") }}
          </div>
        </div>
        <i
            class="el-icon-close close-dia"
            @click.stop="showDoctorAddress = false"
        />

        <!--        <img-->
        <!--          @click.stop="showDoctorAddress = false"-->
        <!--          class="close-dia"-->
        <!--          src="../../../common/imgs/expressage_birdie/dia_close.png"-->
        <!--          alt=""-->
        <!--        />-->
      </div>
      <div class="dia-content">
        <div v-if="!addressList.length" class="no-data">
          <img alt="" src="../../../common/imgs/personal/no-address.png"/>
          <span>{{ $t("yssh.nzwtjrhshdz") }}</span>
        </div>
        <div
            v-for="(item, index) in addressList"
            :key="index"
            class="address-item"
        >
          <AddressCard
              :info="item"
              :isCreated="true"
              :showDefault="true"
              @cancel="editCurrent"
              @confirm="choosenCurrent"
          />
        </div>
      </div>
      <div class="dia-footer"></div>
    </el-dialog>
    <AddressEdit
        :editId="editId"
        :isEdit="isEdit"
        :visible="visible"
        @cancel="visible = false"
        @confirm="confirmAddress"
    />
  </div>
</template>

<script>
import FullLoading from "components/full-loading/full-loading";
import $ from "jquery";
import {formatDate, getUserId, notifyMsg} from "common/js/util";
import AddressCard from "../../../components/address-card/index.vue";
import AddressEdit from "../../../components/address-edit/index.vue";
import {
  casesDetail,
  clinic_List,
  clinicAddress,
  createCases,
  cureProblemList,
  editCases,
  optionalListByProduct,
  PublicSendAddressList
} from "common/api/cases";
import {mapActions, mapGetters, mapState} from "vuex";
import {extend, filter, find, flattenDeep, get, map, pickBy} from "lodash";
import moment from "moment";
import CDate from "common/js/CDate";
import {changeRouteQuery} from "../../../common/js/Fn";
import AddressParse from "address-parse";

export default {
  props: {
    productClear: {
      required: false
    },
    tabIndex: {
      required: false
    }
  },
  data() {
    const _this = this;
    return {
      birthday: "",
      clinicDisableText: "",
      disabledDate: {
        customPredictor: function (date) {
          if (date > Date.now() - 1000 * 60 * 60 * 24 * 30 * 12 * 5) {
            return true;
          }
        }
      },
      contactWayList: [
        {idx: 0, key: "1", value: this.$t("cases.createUser.sjhm")},
        {idx: 1, key: "2", value: this.$t("birdie.gddh")}
      ],
      editId: "",
      isEdit: false,
      visible: false,
      addressList: [],
      showDoctorAddress: false,
      doctorAddressId: "",
      doctorAddressInfo: {},
      dialogVisible: false,
      isLoading: false,
      address: "",
      helpFlag: "",
      bindProductId: "",
      userForm: {
        helpFlag: "",
        sex: "", //性别
        birthday: "",
        realName: "",
        mobile: "",
        receiverMobile: "",
        province: "", //省
        city: "", //市
        area: "", //区
        address: "", //地址
        productId: "", //产品
        bindProductId: "",
        clinicId: "", //诊所
        receiveType: "1",
        phoneArea: "",
        receiver: "",
        doctorId: getUserId()
      }, // 表单form
      contactWay: "1",
      caseNumber: "", // 患者号
      clinicList: [], // 诊所列表
      clinicAddressList: [],
      clinicAddressId: "",
      productList: [], // 产品列表
      cityData: [],
      theCityList: [],
      countyList: [],
      clinicListDom: null,
      productListDom: null,
      clickObj: {
        clinicIndex: 0,
        productIndex: 0
      },
      caseId: "",
      clinicNumber: "",
      backClinicId: "",
      clinicMsgObj: {},
      productMsgObj: {},
      CITY: [], // 总省份数据
      lang: localStorage.getItem("user_lang") || "zh_CN",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      details: "",
      cannotSelectList: [],

      problemList: [],
      sumProblemList: [],
      diagnosisProblem: {},

      isResponse: 0,
      productType: "",
      bindProductNumber: "",
      signedClinicList: []
    };
  },
  watch: {
    cityList: {
      handler(cityData) {
        if (cityData?.length) {
          this.CITY = cityData;
          this.cityData = cityData;
          const {province, city} = this.userForm;
          const list = cityData.filter(item => item.id === province);
          if (list.length) {
            this.theCityList = cityData.filter(
                item => item.id === province
            )[0].sub;
            this.countyList = this.theCityList.filter(
                item => item.id === city
            )[0].sub;
          }
        }
      },
      deep: true,
      immediate: true
    },
    // clinicMsgObj: {
    //   handler(val) {
    //     this.$emit("getClinicMsg", val?.[this.userForm.clinicId]);
    //   },
    //   deep: true,
    //   immediate: true
    // },
    // productMsgObj: {
    //   handler(val) {
    //     this.$emit("getProductMsg", val?.[this.userForm.productId]);
    //   },
    //   deep: true,
    //   immediate: true
    // },
    "userForm.clinicId": {
      handler(val) {
        if (val) {
          this.getClinicList(val);
        } else {
          this.clinicAddressList = [];
          this.clinicAddressId = "";
          this.dialogVisible = false;
        }
      }
    },
    "userForm.productId": {
      handler: function (val) {
        let route = this.$route;
        // this.userForm.bindProductId = "";
        // this.bindProductId = "";
        this.$router.replace({
          name: route.name,
          query: extend({}, route.query, {productId: val})
        });
        if (val) {
          const list = flattenDeep(
              map(this.productList, item => {
                if (item.id === val) {
                  return map(get(item, "signedClinicList"), it => it.id);
                }
                return [];
              })
          );
          this.signedClinicList = list;
        }
      }
    },
    "userForm.bindProductId": {
      handler: function (val) {
        if (val === "0") {
          this.userForm.bindProductId = "";
          this.bindProductId = "";
        } else {
          this.signedClinicList = flattenDeep(
              map(this.bindProductList, item => {
                if (item.id === val) {
                  return map(get(item, "signedClinicList"), it => it.id);
                }
                return [];
              })
          );
        }
      },
      deep: true,
      immediate: true
    },
    "userForm.receiveType": {
      handler: function (val) {
        // 1. 定义公共重置方法（清空邮寄相关信息）
        const resetMailInfo = () => {
          Object.assign(this.userForm, {
            receiver: "",
            phoneArea: "",
            receiverMobile: "",
            contactWay: "1",
            province: "",
            city: "",
            area: "",
            address: ""
          });
        };

        // 2. 根据不同类型处理逻辑
        if (val === "2") {
          // 类型 2：邮寄地址
          this.doctorAddressId = "";
          this.doctorAddressInfo = {};

          if (this.details.receiveType === "2") {
            const addr = this.details.otherReceiveAddress || {};
            Object.assign(this.userForm, {
              province: addr.province || "",
              city: addr.city || "",
              area: addr.area || "",
              address: addr.address || "",
              receiverMobile: addr.phone || "",
              phoneArea: addr.phoneArea || "",
              receiver: addr.receiveUser || "",
              contactWay: addr.contactWay || "1"
            });
          } else {
            resetMailInfo();
          }
        } else {
          // 类型 1 (诊所) 和 类型 3 (医生) 都会重置表单
          resetMailInfo();

          if (val === "3") {
            // 类型 3 的特殊逻辑：处理医生地址回显或默认值
            const isDefaultType3 = this.details.receiveType === "3";
            this.doctorAddressId = isDefaultType3 ? this.details.receiveAddressId : "";
            this.doctorAddressInfo = isDefaultType3 ? this.details.otherReceiveAddress : {};

            // 如果没有地址，自动选中默认地址
            if (!this.doctorAddressId) {
              const defaultAddr = this.addressList.find(item => item.defaultFlag === "1");
              if (defaultAddr) this.choosenCurrent(defaultAddr);
            }
          }
        }
      }
    },
    tabIndex: {
      handler: function (nval) {
        if (nval == 0) {
          this.productList = [];
          this.init(this.$route.query.caseId);
        } else {
          return;
        }
      }
    },
    productClear: {
      handler: function (val) {
        if (val) {
          this.productList = [];
          this.getProductList();
          if (!this.details) {
            this.userForm.productId = "";
          }
        }
      }
    },
    productList: {
      handler(val) {
        if (!val?.length) return;

        // 1. 统一获取当前选中的产品 ID
        // 逻辑简化：如果 bindProductId 有值且不为 "0"，取它，否则取 productId
        const isBind = this.userForm.bindProductId && this.userForm.bindProductId !== "0";
        const currentPid = isBind ? this.userForm.bindProductId : this.userForm.productId;

        // 2. 确定数据源
        const targetList = isBind ? this.bindProductList : val;

        // 3. 查找匹配的产品（使用 find 代替 forEach/map，效率更高）
        const matchedProduct = targetList.find(item => item?.id === currentPid);
        const signedList = matchedProduct?.signedClinicList || [];

        // 4. 更新同步状态
        // 提取 ID 列表供后续选择器使用
        this.signedClinicList = signedList.map(c => c.id);

        // 更新对话框可见性标识（匹配当前 userForm.clinicId 的 rdtId）
        const currentClinic = signedList.find(c => c.id === this.userForm.clinicId);
        if (currentClinic) {
          this.dialogVisible = currentClinic.rdtId;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      language: state => state.language,
      cityList: state => state.cityList
    }),

    ...mapGetters({
      commonAddProductList: "getCommonAddProductList" //追加产品列表
    }),
    // 1. 获取当前选中产品的“未签约诊所ID列表”
    signedClinicIds() {
      const pList =
          this.bindProductList?.length > 0
              ? this.bindProductList
              : this.productList;
      const pid = this.userForm.bindProductId || this.userForm.productId;
      return flattenDeep(
          map(pList, item => {
            if (item.id === pid) {
              return map(get(item, "signedClinicList"), it => it.id);
            }
            return [];
          })
      )
    },
    showRdtAssist() {
      const pid = this.userForm.bindProductId || this.userForm.productId;
      const cid = this.userForm.clinicId;
      const pList =
          this.bindProductList?.length > 0
              ? this.bindProductList
              : this.productList;
      if (!pid || !cid) return false;

      // 从产品列表中找到当前选中的产品，检查该诊所是否配置了 rdtId
      const currentProduct = pList.find(item => item.id === pid);
      if (currentProduct?.signedClinicList) {
        const clinicConfig = currentProduct.signedClinicList.find(
            c => c.id === cid
        );
        return !!clinicConfig?.rdtId; // 存在 rdtId 则返回 true
      }
      return false;
    },
    disableClinicSelect() {
      if (this.details) {
        // if (this.details["type"] === "2") {
        //   this.clinicDisableText = "产品追加，不支持切换";
        //   return true;
        // }
        if (
            this.details.curePlanInfo &&
            this.details?.curePlanInfo?.["reopenNumber"] !== 0
        ) {
          this.clinicDisableText = "病例重启，不支持切换";
          return true;
        }
      }
    },
    bindProductList() {
      // this.bindProductId = "";
      const current = this.productList.filter(
          it => it.id === this.$route.query.productId
      );
      return current[0]?.bindProductList || [];
    },

    isDisabledProduct() {
      const {details, productList, sumProblemList = [], problemList = []} = this;
      if (!details) return false;

      // 1. 提取变量，增强可读性
      const {
        productSystemType: sysType,
        type,
        cureType,
        productId,
        nextStatus,
        number,
        reopenFlag
      } = details;

      const isSys56 = ["5", "6"].includes(sysType);
      const isResubmit = nextStatus === "to_resubmit";
      const hasSumProblems = sumProblemList.length > 0;
      const hasCurrentProblems = problemList.length > 0;

      // 2. 核心逻辑：拦截式返回（最强规则优先）

      // 规则 A：5/6系统且类型不为0，强制禁用
      if (isSys56 && type !== "0") return true;

      // 规则 B：F类型治疗不禁用
      if (cureType === "F") return false;

      // 规则 C：重新提交状态下的复杂校验
      if (isResubmit) {
        // 只有总问题，没有当前问题 -> 禁用
        if (hasSumProblems && !hasCurrentProblems) return true;
        // 5/6系统且存在问题时，若number不为1 -> 禁用
        if (hasSumProblems && hasCurrentProblems && isSys56 && number !== 1) return true;
      }

      // 规则 D：重开逻辑 (匹配产品列表)
      if (reopenFlag === "1") {
        return productList.some(item => productId === item.id);
      }

      return false;
    },
    isDisabledBindProduct() {
      if (this.details["cureType"] === "F") {
        return false;
      }
      let boolean = this.productList.some(
          item => this.details["productId"] === item.id
      );
      if (
          this.details.nextStatus === "to_resubmit" &&
          !!this.sumProblemList.length &&
          !this.problemList.length
      ) {
        return true;
      } else if (this.details.reopenFlag === "1") {
        return !boolean ? false : true;
      }
    }
  },
  methods: {
    moment,
    ...mapActions({
      getCommonAddProductList: "actionGetCommonAddProductList" //追加产品列表
    }),

    renderAddressText() {
      const {
        receiveUser,
        sender,
        contactWay,
        phoneArea,
        phone,
        provinceName,
        cityName,
        areaName,
        address
      } = this.doctorAddressInfo;
      return `${sender || receiveUser}- ( ${
          contactWay === "2" ? `${phoneArea}-${phone}` : phone
      } ) -${provinceName}-${cityName}-${areaName}-${address}`;
    },
    confirmAddress() {
      this.visible = false;
      this.getSendAddressList();
    },
    choosenCurrent(info) {
      this.doctorAddressInfo = info;
      this.doctorAddressId = info.id;
      this.showDoctorAddress = false;
    },
    addDoctorAddress() {
      this.editId = "";
      this.isEdit = false;
      this.visible = true;
    },
    editCurrent(info) {
      this.editId = info.id;
      this.isEdit = true;
      this.visible = true;
    },
    getClinicList(id) {
      clinicAddress({refCode: id, refType: "CLINIC"}).then(data => {
        this.clinicAddressList = data.map(v => {
          if (this.details.clinicId || this.userForm.clinicId) {
            if (v.defaultFlag === "1") {
              this.clinicAddressId = v.id;
            }
          }
          const {
            id,
            receiveUser,
            phone,
            provinceName,
            cityName,
            areaName,
            address,
            phoneArea,
            contactWay
          } = v;
          const phoneNum = contactWay === "2" ? `${phoneArea}-${phone}` : phone;
          v.clinicAddress = `${receiveUser}-${phoneNum}-${provinceName}-${cityName}-${areaName}-${address}`;
          return v;
        });
      });
    },
    getSendAddressList() {
      PublicSendAddressList({
        refCode: localStorage.getItem("userId"),
        refType: "DOCTOR"
      }).then(res => {
        this.addressList = res;
        res.forEach(item => {
          if (this.doctorAddressInfo?.id === item.id) {
            this.doctorAddressInfo = item;
          }
        });
      });
    },
    showDoctorAddressDia() {
      this.showDoctorAddress = true;
    },
    changeContactWay(e) {
      this.userForm.phoneArea = "";
      this.userForm.receiverMobile = "";
    },
    selectProduct(id) {
      if (id) {
        if (!this.disableClinicSelect) {
          let obj = find(this.productList, item => item.id === id);
          this.cannotSelectList = map(get(obj, "signedClinicList"), item => {
            return item.id;
          });
          this.changeRoute({
            productId: obj.id
          });
          this.productType = get(obj, "cureType");
        }
        this.userForm.productId = id;
        this.userForm.bindProductId = "";
        this.selectClinicId(this.userForm.clinicId);
      } else {
        this.productType = "";

        this.dialogVisible = false;
      }
      this.userForm.helpFlag = "";
      this.helpFlag = "";
      this.userForm.bindProductId = "";
      this.bindProductId = "";
      this.$emit("getProductMsg", this.productMsgObj[id]);
    },
    selectBindProduct(id) {
      this.$set(this.userForm, "bindProductId", id);
      this.bindProductId = id;
      this.selectClinicId(this.userForm.clinicId);
      if (id) {
        const product = this.bindProductList.find(item => item.id === id);
        if (product) {
          this.$set(this, "bindProductNumber", product.number);
        }
      } else {
        this.bindProductNumber = ""; // 或者设置为默认值
      }
    },
    datePickerValue(val) {
      this.birthday = val;
      this.userForm.birthday = val;
    },
    closeDialog() {
      this.userForm.helpFlag = "";
      sessionStorage.setItem("needRTD", "0");
      this.dialogVisible = false;
    },
    needRDT(num) {
      this.userForm.helpFlag = num;
      sessionStorage.setItem("needRTD", num);
      this.dialogVisible = false;
    },
    jumpClinicalPreferences() {
      sessionStorage.setItem("isShowRTD", true);
      const href = "/cases/clinicalPreferences";
      window.open(href, "_blank");
    },
    async getProductList(type, data) {
      const {id: caseId, reopenFlag, type: detailType} = this.details || {};

      // 1. 状态锁定，防止重复请求
      this.isResponse = 1;

      try {
        if (type === "2") {
          // 场景 A：常规新增产品逻辑
          await this.getCommonAddProductList({
            platformType: "0",
            type,
            caseId
          });
          this.productList = this.commonAddProductList?.list || [];
        } else {
          // 场景 B：可选产品列表逻辑
          const params = {
            platformType: "0",
            type,
            // 只有满足特定条件才注入 caseId，保持参数干净
            ...((reopenFlag === "1" || this.sumProblemList?.length || detailType === "1") && {caseId})
          };

          const res = await optionalListByProduct(params);
          const list = res || [];
          this.productList = list;

          // 2. 映射表构建与当前产品匹配 (O(n) 复杂度完成)
          const productMap = {};
          let matchedProduct = null;
          const targetId = this.$route.query.productId;

          list.forEach(item => {
            productMap[item.id] = {name: item.name};
            if (item.id === targetId) matchedProduct = item;
          });

          this.productMsgObj = productMap;

          // 3. 业务规则处理：非 5,6 系统时同步产品类型
          if (matchedProduct && !["5", "6"].includes(matchedProduct.systemType)) {
            this.productType = matchedProduct.cureType;
          }

          // 4. 通知父组件，确保数据同步
          this.$emit("getProductMsg", productMap[this.userForm.productId] || null);
        }
      } catch (error) {
        console.error("Product list fetch failed:", error);
      } finally {
        // 5. 统一的状态重置延迟
        setTimeout(() => {
          this.isResponse = 0;
        }, 500);
      }
    },
    selectClinicId(_id) {
      let productId =
          this.userForm.bindProductId !== "0" && this.userForm.bindProductId
              ? this.userForm.bindProductId
              : this.userForm.productId;
      const list =
          this.userForm.bindProductId !== "0" && this.userForm.bindProductId
              ? this.bindProductList
              : this.productList;
      if (_id && productId) {
        list?.forEach(item => {
          if (item?.id === productId) {
            item?.signedClinicList?.forEach(cItem => {
              if (_id === cItem?.id) {
                this.dialogVisible = cItem?.rdtId;
              }
            });
          }
        });
      } else {
        this.dialogVisible = false;
      }
    },
    selectedClinic(_id) {
      // 1. 批量重置 userForm 相关字段
      Object.assign(this.userForm, {
        province: "",
        city: "",
        area: "",
        address: "",
        receiverMobile: "",
        phoneArea: "",
        receiver: "",
        contactWay: "1",
        helpFlag: "",
        receiveType: "1"
      });

      // 2. 状态与标志位重置
      this.doctorAddressId = "";
      this.clinicAddressId = "";
      this.doctorAddressInfo = {};
      this.helpFlag = "";
      sessionStorage.setItem("needRTD", "0");

      if (!_id) {
        // 场景 A：清空诊所选择
        this.clinicAddressList = [];
        this.dialogVisible = false;
      } else {
        // 场景 B：选中有效诊所
        this.getClinicList(_id);

        // 确定当前使用的产品 ID 和对应的产品列表
        const isBind = this.userForm.bindProductId && this.userForm.bindProductId !== "0";
        const _productId = isBind ? this.userForm.bindProductId : this.userForm.productId;
        const targetList = isBind ? this.bindProductList : this.productList;

        // 3. 校验逻辑优化：使用 find 代替 forEach 提升效率
        if (_productId && targetList) {
          const currentProduct = targetList.find(item => item?.id === _productId);
          const matchedClinic = currentProduct?.signedClinicList?.find(c => c?.id === this.userForm.clinicId);

          // 如果匹配到签约诊所，设置对话框可见性（rdtId）
          if (matchedClinic) {
            this.dialogVisible = matchedClinic.rdtId;
          }
        }
      }

      // 4. 统一触发事件
      const currentClinicMsg = this.clinicMsgObj?.[this.userForm.clinicId] || null;
      this.$emit("getClinicMsg", currentClinicMsg);
    },
    changeRdt(val) {
      this.userForm.helpFlag = val;
      this.helpFlag = val;
      sessionStorage.setItem("needRTD", val);
    },
    toStep(d, dom) {
      // 10.53
      let {clinicIndex} = this.clickObj;
      const len = Math.floor(this[dom].children("li").length / 4);
      if (d === "0") {
        // 向左
        if (clinicIndex > 0) {
          this.clickObj.clinicIndex -= 1;
        }
      } else {
        if (clinicIndex < len) {
          ++this.clickObj.clinicIndex;
        }
      }
      this[dom].animate(
          {
            marginLeft: -10.53 * this.clickObj.clinicIndex + "rem"
          },
          600
      );
    },
    enterStep(dom) {
      const parentDom = dom === "productListDom" ? "product_box" : "clinic_box";
      const len = this[dom].children("li").length;
      if (len > 3) {
        $(`.${parentDom} .pre_p, .${parentDom} .next_p`)
            .css({
              opacity: 1
            })
            .fadeIn(500);
      }
    },
    leaveStep(dom) {
      const parentDom = dom === "productListDom" ? "product_box" : "clinic_box";
      const len = this[dom].children("li").length;
      if (len > 3) {
        $(`.${parentDom} .pre_p, .${parentDom} .next_p`)
            .css({
              opacity: 0
            })
            .fadeOut(300);
      }
    },
    // 选择省
    changeProvince() {
      const {province} = this.userForm;
      this.theCityList = this.CITY.filter(item => item.id === province)[0].sub;
      this.countyList = [];
      this.userForm = {
        ...this.userForm,
        city: "",
        area: ""
      };
    },
    // 选择市
    changeCity() {
      const {city} = this.userForm;
      this.countyList = this.theCityList.filter(
          item => item.id === city
      )[0].sub;
      this.userForm = {
        ...this.userForm,
        area: ""
      };
    },
    saveData(key) {
      let {
        clinicId,
        receiverMobile,
        birthday,
        mobile,
        realName,
        sex,
        province,
        city,
        area,
        address,
        productId,
        receiveType,
        receiver,
        phoneArea
      } = this.userForm;
      if (key !== 5) {
        const f = this.userForm;
        const t = (k) => this.$t(k);
        const isMobile = (val) => /^1[3-9]\d{9}$/.test(val);

        // 1. 建立校验规则清单 (数组顺序即为校验顺序)
        const rules = [
          // 全局基础信息
          [!f.realName, t("cases.createUser.qtxhz")],
          [!f.sex, t("cases.createUser.qtxxb")],
          [!f.birthday, t("cases.createUser.qtxcs")],
          [!f.productId, t("cases.createUser.qxzcp")],
          [!f.clinicId, t("cases.createUser.qxzzs")],
          [f.mobile && !isMobile(f.mobile), t("cases.createUser.qsrlxdh")],
          [this.bindProductList.length && !f.bindProductId, t("cases.createUser.qsrtcbdcp"), 2500],

          [!f.receiveType, "请选择收货类型"],
          // 类型1、3：地址校验
          [f.receiveType === "1" && !this.clinicAddressId, t("yssh.qxzysshdz")],
          [f.receiveType === "3" && !this.doctorAddressId, t("yssh.qxzysshdz")],
          // 类型2：收货人信息
          [f.receiveType === "2" && !f.receiver, t("cases.createUser.qtxsjrxm")],
          // 类型2：座机校验 (区号 + 号码)
          [f.receiveType === "2" && this.contactWay == 2 && !f.phoneArea, t("birdie.qtxqh")],
          [f.receiveType === "2" && this.contactWay == 2 && !f.receiverMobile, t("birdie.qtxdhhm")],
          [f.receiveType === "2" && this.contactWay == 2 && !/^0\d{2,4}$/.test(f.phoneArea), t("birdie.qhsryw")],
          [f.receiveType === "2" && this.contactWay == 2 && !/^\d{7,8}$/.test(f.receiverMobile), t("birdie.dhhmsryw")],
          // 类型2：手机校验
          [f.receiveType === "2" && this.contactWay != 2 && !f.receiverMobile, t("cases.createUser.qsrsjrsjhm")],
          [f.receiveType === "2" && this.contactWay != 2 && !isMobile(f.receiverMobile), t("birdie.sjrsjhmyw")],
          // 类型2：省市区地址
          [f.receiveType === "2" && (!f.province || !f.city || !f.area || !f.address), t("cases.createUser.qtxssqjdz")],

        ];

        // 2. 找到第一个不符合规则的项 (命中则报错并拦截)
        const error = rules.find(r => r[0]);

        if (error) {
          notifyMsg(this, "warning", error[1], error[2] || 2000);
          this.$emit("saveError");
          return Promise.reject();
        }
      }

      // 1. 加工数据 (用最直接的覆盖逻辑)
      this.isLoading = true;
      const f = this.userForm;
      const formattedDate = f.birthday ? formatDate(f.birthday, "yyyy-MM-dd") : "";
      this.userForm.birthday = this.birthday = formattedDate;

// 构造提交对象 (利用解构和逻辑合并)
      let submitData = {
        ...f,
        helpFlag: f.helpFlag || this.helpFlag || "0",
        id: this.caseId || undefined,
        doctorId: this.caseId ? undefined : getUserId()
      };

// 处理地址关联 (用最简单的 key 映射)
      const receiveConfig = {
        '1': {receiveAddressId: this.clinicAddressId},
        '3': {receiveAddressId: this.doctorAddressId},
        '2': {receiver, receiverMobile, province, city, area, address, contactWay: this.contactWay}
      };
      Object.assign(submitData, receiveConfig[receiveType]);
      if (receiveType === "1") delete submitData.contactWay;

// 处理产品绑定
      const current = this.productList.find(it => it.id === f.productId);
      const bindItem = current?.bindProductList?.find(it => it.id === f.bindProductId);
      this.bindProductNumber = submitData.number = bindItem?.number || undefined;

// 2. 暂存拦截 (key 5)
      sessionStorage.setItem("needRTD", submitData.helpFlag);
      if (key === 5) {
        sessionStorage.setItem("createUserForm", JSON.stringify(submitData));
        this.isLoading = false;
        return Promise.resolve();
      }

// 3. 统一调用接口
      const api = this.caseId ? editCases : createCases;
      return api(pickBy(submitData)).then(res => {
        // 成功处理：无论新建还是编辑，都要存 session 和触发 emit
        sessionStorage.setItem("createUserForm", JSON.stringify(f));
        this.isLoading = false;
        notifyMsg(this, "success", this.$t("cases.createUser.yzc"), 2500);
        this.$emit("getClinicMsg", this.clinicMsgObj[clinicId]);
        this.$emit("getProductMsg", this.productMsgObj[productId]);

        // 根据结果跳转：新建需赋值 id，编辑直接跳
        const query = this.caseId
            ? {caseId: this.caseId, productType: this.productType}
            : {caseId: res.id, curePlanId: res.currentCurePlanId, productType: res.cureType};

        if (!this.caseId) {
          Object.assign(this, {caseId: res.id, caseNumber: res.caseNumber, details: res});
          sessionStorage.setItem("casesRealName", res.userName);
        }
        changeRouteQuery(this, query);
      }).catch(err => {
        if (err?.errorCode === "AIS00128") {
          Object.assign(this.userForm, {productId: ""});
          this.productList = [];
          this.getProductList();
        }
        this.isLoading = false;
        this.$emit("saveError");
      });
    },
    changeRoute(args) {
      let route = this.$route;
      this.$router.replace({
        name: route.name,
        query: extend({}, route.query, args)
      });
    },
    getProblem(par) {
      return cureProblemList({
        caseId: this.details.id,
        curePlanId: par.currentCurePlanId
      }).then(data => {
        const diagnosisProblem = {};
        data.forEach(item => {
          diagnosisProblem[item.groupNo] = item.content;
        });
        this.diagnosisProblem = diagnosisProblem;
        this.sumProblemList = data;
        this.problemList = filter(data, item => item.groupNo === 0);
        if (this.problemList.length) {
          this.backClinicId = par.clinicId;
        }
      });
    },
    init(id) {
      // getCityList().then(_cityData => {
      if (id) {
        casesDetail(id).then(data => {
          this.details = data;
          this.bindProductNumber = data["number"];
          // this.userForm.bindProductId = data?.bindProductId;
          this.bindProductId = data?.bindProductId;
          if (data.currentCurePlanId) {
            this.getProblem(data).then(() => {
              this.getProductList(data["type"], data);
            });
          } else {
            this.getProductList(data["type"]);
          }
          this.productType = this.details.cureType || "A";
          this.changeRoute({
            productType: this.details.cureType || "A",
            curePlanId: data.currentCurePlanId || ""
          });
          const {
            userInfo,
            productId,
            clinicId,
            doctorId,
            caseNumber,
            receiver,
            helpFlag,
            receiveType,
            bindProductId
          } = data;
          if (data.helpFlag === "1") {
            sessionStorage.setItem("needRTD", "1");
          } else {
            sessionStorage.setItem("needRTD", "0");
          }
          if (data.receiveType === "1") {
            this.clinicAddressId = data.receiveAddressId;
          }
          if (data.receiveType === "3") {
            this.doctorAddressId = data.receiveAddressId;
            this.doctorAddressInfo = data.otherReceiveAddress;
          }
          this.caseNumber = caseNumber;
          this.birthday = new CDate(userInfo.birthday).format("yyyy-MM-dd");
          this.userForm = {
            sex: userInfo.sex,
            birthday: new CDate(userInfo.birthday).format("yyyy-MM-dd"),
            realName: userInfo.realName,
            mobile: userInfo.mobile,
            province: get(data.otherReceiveAddress, "province") || "",
            city: get(data.otherReceiveAddress, "city") || "",
            area: get(data.otherReceiveAddress, "area") || "",
            address: get(data.otherReceiveAddress, "address") || "",
            receiverMobile: get(data.otherReceiveAddress, "phone") || "",
            receiveType,
            bindProductId,
            phoneArea: get(data.otherReceiveAddress, "phoneArea") || "",
            receiver: get(data.otherReceiveAddress, "receiveUser"),
            clinicId,
            doctorId,
            helpFlag
          };

          if (productId !== "0") {
            this.userForm.productId = this.$route.query.productId || productId;
            if (this.userForm.productId !== data.productId) {
              this.userForm.bindProductId = "";
              this.bindProductId = "";
            }
          }
          this.contactWay = get(data.otherReceiveAddress, "contactWay") || "1";
          const {province, city} = this.userForm;
          const list = this.CITY.filter(item => item.id === province);
          if (list.length) {
            this.theCityList = this.CITY.filter(
                item => item.id === province
            )[0].sub;
            this.countyList = this.theCityList.filter(
                item => item.id === city
            )[0].sub;
          }
          this.helpFlag = data.helpFlag;
          if (this.details.clinicId) {
            this.getClinicList(this.details.clinicId);
          }
          clinic_List({
            doctorId: getUserId(),
            // status: "1",
            sort: "id"
          })
              .then(data => {
                this.isLoading = false;
                const obj = {};
                this.clinicList = data;

                // this.clinicList = data.map(item => {
                //   const oItem = item.clinicInfo;
                //   obj[oItem.id] = {
                //     name: oItem.name,
                //     pic: this.$PicPrefix + oItem.frontPicture
                //   };
                //   return {
                //     id: oItem.id,
                //     name: oItem.name,
                //     caseNumber: oItem.number,
                //     address: `${oItem.province}-${oItem.city}-${oItem.area}-${oItem.address}`,
                //     description: oItem.description,
                //     frontPicture: this.$PicPrefix + oItem.frontPicture,
                //     RDTId: get(item, "clinicInfo.rdtId"),
                //     clinicInfo: item.clinicInfo
                //   };
                // });
                this.userForm.receiveType = this.details.receiveType;
                this.clinicMsgObj = obj;
                if (id) {
                  setTimeout(() => {
                    this.$emit(
                        "getClinicMsg",
                        obj[this.userForm.clinicId] || null
                    );
                  }, 0);
                }
                this.selectClinicId(
                    this.details.clinicId || this.userForm.clinicId
                );
              })
              .catch(() => {
                this.isLoading = false;
              });
        });
      } else {
        const _clinicId = JSON.parse(
            sessionStorage.getItem("createUserForm") || ""
        ).clinicId;
        if (_clinicId) {
          this.getClinicList(_clinicId);
        }

        this.getProductList("0");
        clinic_List({
          doctorId: getUserId(),
          status: "1",
          sort: "id"
        })
            .then(data => {
              this.isLoading = false;
              const obj = {};
              this.clinicList = data;
              // this.clinicList = data.map(item => {
              //   const oItem = item.clinicInfo;
              //   obj[oItem.id] = {
              //     name: oItem.name,
              //     pic: this.$PicPrefix + oItem.frontPicture
              //   };
              //   return {
              //     id: oItem.id,
              //     name: oItem.name,
              //     caseNumber: oItem.number,
              //     address: `${oItem.province}-${oItem.city}-${oItem.area}-${oItem.address}`,
              //     description: oItem.description,
              //     frontPicture: this.$PicPrefix + oItem.frontPicture,
              //     RDTId: get(item, "clinicInfo.rdtId"),
              //     clinicInfo: item.clinicInfo
              //   };
              // });
              this.userForm.receiveType = this.details.receiveType;
              this.clinicMsgObj = obj;
              if (id) {
                setTimeout(() => {
                  this.$emit("getClinicMsg", obj[this.userForm.clinicId] || null);
                }, 0);
              }
              this.selectClinicId(
                  this.details.clinicId || this.userForm.clinicId
              );
            })
            .catch(() => {
              this.isLoading = false;
            });
      }
      // this.CITY = _cityData;
      const createUserForm = sessionStorage.getItem("createUserForm") || "";
      if (createUserForm) {
        this.userForm = {
          ...JSON.parse(createUserForm),
          ...pickBy(this.userForm)
        };
        this.helpFlag = this.userForm.helpFlag;
        // const { province, city } = this.userForm;

        // const list = this.CITY.filter(item => item.id === province);
        // if (list.length) {
        //   this.theCityList = this.CITY.filter(
        //     item => item.id === province
        //   )[0].sub;
        //   this.countyList = this.theCityList.filter(
        //     item => item.id === city
        //   )[0].sub;
        // }
      }
      // });
    },
    getMessage() {
      const [res] = AddressParse.parse(this.address);
      if (!res) return;

      const {province, city, area, mobile, phone, name, details} = res;
      const form = this.userForm;

      const matchAndGetSub = (list, name, level) => {
        if (!name || !list?.length) return [];
        const target = list.find(v => v.name === name || v.name.startsWith(name));
        if (target) {
          form[level] = target.id;
          return target.sub || [];
        }
        return [];
      };

      // 1. 级联匹配省、市、区
      // 匹配省份，返回城市列表
      this.theCityList = matchAndGetSub(this.CITY, province, 'province');

      // 匹配城市，返回县区列表
      if (form.province) {
        this.countyList = matchAndGetSub(this.theCityList, city, 'city');
      }

      // 匹配县区
      if (form.city) {
        matchAndGetSub(this.countyList, area, 'area');
      }

      // 2. 级联重置：如果某一级没匹配上，自动清空后续字段
      if (!province) form.province = "";
      if (!form.province || !city) {
        Object.assign(form, {city: "", area: ""});
        this.countyList = [];
      }
      if (!form.city || !area) form.area = "";

      // 3. 处理联系方式 (使用解构和逻辑合并)
      if (mobile || phone) {
        const isMobile = !!mobile;
        this.contactWay = isMobile ? "1" : "2";
        if (isMobile) {
          form.receiverMobile = mobile;
        } else {
          const [areaCode, num] = phone.split("-");
          Object.assign(form, {phoneArea: areaCode, receiverMobile: num});
        }
      }

      // 4. 基础赋值
      Object.assign(form, {
        receiver: name,
        address: details || ""
      });
    },
    resetMessage() {
      this.address = "";
    }
  },
  components: {
    FullLoading,
    AddressCard,
    AddressEdit
  },
  created() {
    if (this.$route.query.productId) {
      this.userForm.productId = this.$route.query.productId;
    }
    this.isResponse += 1;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    this.isLoading = true;
    let id = this.$route.query.caseId;
    this.caseId = id;
    this.init(id);
    this.getSendAddressList();
  },
  mounted() {
    this.clinicListDom = $(".clinic_list");
    this.productListDom = $(".product_list");
  }
};
</script>

<style lang="scss" scoped>
.dia-header {
  width: 100%;
  height: 58px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .close-dia {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  .title {
    font-size: 18px;
    color: #333333;
    display: flex;
    align-items: center;

    .add-address {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 24px;
      font-size: 14px;
      color: #fcc80e;

      img {
        width: 24px;
        margin-right: 4px;
      }
    }
  }
}

.dia-content {
  padding: 10px 30px;
  height: 600px;
  overflow-y: auto;

  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 184px;
      margin-bottom: 24px;
    }

    span {
      font-size: 14px;
      line-height: 20px;
      color: #999999;
    }
  }

  .address-item {
    margin-bottom: 10px;
  }
}

.dia-footer {
  height: 30px;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.12);
}

/deep/ .address-dia .el-dialog__header {
  padding: 0px;
}

/deep/ .address-dia .el-dialog__body {
  padding: 0px;
}

/deep/ .address-dia .el-dialog {
  border-radius: 8px;
  margin-top: 15vh !important;
}

.doctor-select,
.doctor-select-active {
  cursor: pointer;
  width: 276px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  padding: 0 20px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 32px;
}

.doctor-select {
  background-color: #f4f4f4;
  color: #999999;
}

.doctor-select-active {
  border: 1px solid #bbbbbb;
  color: #333333;
}

.select-text {
  cursor: pointer;
  font-size: 14px;
  color: #fcc80e;
}

.my-el-select {
  /* selecte 框的高度设置，默认是 40px*/
  .el-input__inner {
    height: 0.3rem !important;
  }

  /* 下面设置右侧按钮居中 */
  .el-input__suffix {
    top: 5px;
  }

  .el-input__icon {
    line-height: inherit;
  }

  .el-input__suffix-inner {
    display: inline-block;
  }
}

.date_picker {
  padding: 0 0.19rem;
  width: 2.7rem;
  background-color: #f4f4f4;
}

/deep/ .el-input.is-disabled .el-input__inner {
  height: 0.42rem !important;
}

/deep/ .el-dialog__header {
  padding-top: 70px;
}

/deep/ .el-dialog__title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $main_theme_color_333;
  font-size: 18px;
}

/deep/ .el-dialog__footer {
  padding-top: 0;
}

/deep/ .dialog-footer {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}

/deep/ .el-dialog__body {
  padding: 0;
}

.rdt_text {
  display: flex;
  justify-content: center;
  color: $main_theme_color_999;
  font-size: 14px;
}

.create_user {
  background-color: #fff;
  border-radius: 0.06rem;
  padding: 0.16rem 0.3rem 2rem;

  .user_head {
    padding-bottom: 0.16rem;
    border-bottom: 0.01rem solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;

    .user_head_left {
      display: flex;
      align-items: center;
      font-size: 0.18rem;

      .vertical_line {
        display: inline-block;
        width: 0.04rem;
        height: 0.26rem;
        background-color: $main_theme_color;
        margin-right: 0.1rem;
      }
    }

    .user_head_p {
      display: flex;
      align-items: center;
      color: $main_theme_color_333;

      .user_head_sp {
        font-size: 0.14rem;
        margin-right: 0.1rem;
      }

      .case_number {
        font-size: 0.2rem;
      }
    }
  }

  .form_ul {
    padding-top: 0.3rem;
    //margin-bottom: 0.51rem;
    font-size: 0.16rem;

    .f_single {
      display: flex;
      align-items: center;
      margin-bottom: 0.3rem;

      .f_single_left {
        margin-right: 0.2rem;
        width: 1.3rem;
        text-align: right;
        float: right;
        color: $main_theme_color_333;
        white-space: nowrap;

        span {
          color: $main_theme_color_red;
          font-size: 0.14rem;
        }
      }

      .f_single_right {
        flex: 1;
        border-radius: 0.02rem;
        color: $main_theme_color_333;
        position: relative;

        input {
          width: 2.74rem;
          height: 0.4rem;
          box-sizing: border-box;
          outline: none;
          padding-left: 0.19rem;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
        }

        .select_box {
          display: flex;
          align-items: center;
          margin-bottom: 0.2rem;

          select {
            width: 2.74rem;
            height: 0.4rem;
            border: none;
            background-color: #f4f4f4;
            padding: 0.1rem 0.19rem;
            box-sizing: border-box;
          }
        }

        .iup_box {
          width: 5.68rem;

          input {
            width: 100%;
            height: 0.42rem;
          }
        }
      }
    }
  }

  .clinic_box,
  .product_box {
    overflow: hidden;
    position: relative;
    margin-bottom: 0.51rem;
  }

  .clinic_list {
    margin-top: 0.3rem;
    padding-left: 30px;
    display: flex;
    flex-flow: row wrap;
    position: relative;
    z-index: 1;

    .clinic_single {
      display: inline-block;
      width: 2.58rem;
      margin-right: 0.64rem;
      margin-bottom: 0.3rem;
      cursor: pointer;
      position: relative;

      .mask_layer {
        width: 2.58rem;
        height: 176px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 8px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .clinic_pic {
        height: 176px;
        margin-bottom: 0.1rem;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 0.04rem;
        position: relative;

        .clinic_pic_selected {
          display: inline-block;
          width: 0.24rem;
          height: 0.24rem;
          position: absolute;
          right: 10px;
          top: 10px;
          background-size: 100% 100%;
          background-image: url("../../../common/imgs/case/select_clinic.png");
        }
      }

      .clinic_single_p {
        color: $main_theme_color_333;
        font-size: 0.16rem;
        margin-bottom: 0.04rem;
        line-height: 0.2rem;
      }

      .desc_p {
        color: $main_theme_color_333;
        font-size: 0.16rem;
        display: flex;
        height: auto;
      }

      .clinic_desc {
        margin-bottom: 0.2rem;
        width: 73%;

        p {
          height: 0.18rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .clinic_product {
        width: 73%;

        p {
          white-space: normal;
          line-height: 0.2rem;
          margin-top: -0.02rem;
        }
      }

      .veil_box {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0;
        z-index: 9;
      }
    }

    & div:nth-child(4n) {
      margin-right: 0;
    }
  }

  .pre_p,
  .next_p {
    position: absolute;
    top: 0.34rem;
    width: 0.4rem;
    height: 1.64rem;
    cursor: pointer;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    display: none;
  }

  .pre_p {
    left: 0;
  }

  .next_p {
    right: 0;
  }
}

.dia_problem {
  margin-top: 10px;
  background: #f4f4f4;
  padding: 10px 16px 10px;

  h5 {
    font-size: 0.22rem;
    color: $main_theme_color_333;
    margin-bottom: 10px;
  }

  span {
    margin-right: 0.2rem;
  }

  .pro_box {
    word-break: break-all;
    font-size: 0.16rem;
    line-height: 0.3rem;
    color: $main_theme_color_333;
  }
}

.create_user .form_ul .f_single .f_single_right .select_box select {
  color: $main_theme_color_999 !important;
}

.no_need_btn_en {
  width: 150px !important;
}

.no_need_btn {
  width: 96px;
  height: 36px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #bbbbbb;
  text-align: center;
}

.need_btn {
  width: 96px;
  height: 36px;
  background: #f2bf3e;
  border-radius: 4px;
}

.message-add {
  margin-top: 20px;
  width: 600px !important;
  border: 1px solid #bbbbbb;
  border-radius: 5px;
  padding: 10px;
}

.message-add::placeholder {
  font-size: 14px;
  line-height: 24px;
  color: rgb(153, 153, 153);
}

.message-parse {
  display: inline-block;
  margin-left: 10px;
  padding-bottom: 10px;
  color: rgb(252, 200, 14);
  cursor: pointer;
}

.message-reset {
  display: inline-block;
  margin-left: 10px;
  padding-bottom: 10px;
  cursor: pointer;
}

.tip {
  font-size: 14px;
  color: #ed4027;
  letter-spacing: 1px;
}

.rdt_btn {
  width: 96px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #bbbbbb;
  line-height: 36px;
  font-size: 14px;
  color: #333333;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
  box-sizing: border-box;
  transition: 0.2s all;
}

.rdt_btn_active {
  background: $main_theme_color;
  border: 1px solid $main_theme_color;
  box-sizing: border-box;
  transition: 0.2s all;
}

.icon_question {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-size: cover !important;
  background: url("../../../common/imgs/case/question.png") no-repeat;
  margin-left: 5px;
}

.disabled_txt {
  left: 152px;
  top: 48px;
  font-size: 12px;
  color: #999;
  position: absolute;
}

.el-icon-close {
  font-size: 26px;
  cursor: pointer;
}

.el-icon-close:hover {
  color: $main_theme_color;
}

/* 自定义禁用选项的灰色样式 */
.gray-option.is-disabled {
  color: #999 !important; /* 文字改为灰色 */
  background-color: #f5f7fa; /* 加上淡淡的灰色背景，增加“不可选”的视觉感 */
  cursor: not-allowed; /* 鼠标指针变为禁止状态 */
}

/* 确保鼠标悬停时依然保持灰色，不出现高亮 */
.gray-option.is-disabled:hover {
  background-color: #f5f7fa !important;
  color: #999 !important;
}
</style>
